import { MarketingChannel } from "@redotech/redo-model/marketing";
import { MonthlyDeliverabilityMetrics } from "@redotech/redo-model/marketing/deliverability";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getMonthlyDeliverabilityMetrics = {
  name: "getMonthlyDeliverabilityMetrics" as const,
  input: z.object({
    startDate: zExt.instant(),
    endDate: zExt.instant(),
    channels: z.array(z.enum(MarketingChannel)).optional(),
  }),
  output: z.object({ monthlyMetrics: z.array(MonthlyDeliverabilityMetrics) }),
};
